export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_ONLY_PADRAO_ACTION = 'onlyPadrao';
export const SET_FILTER_ACTION = 'filter';
export const SET_LIST_OPTIONS_ACTION = 'listOptions';
export const RESET_PAGINATION = 'resetPagination';
export const INIT_STATE_ACTION = 'initState';
export const SET_CURRENT_SESSION_STATE_ACTION = 'sessionState';
